// Recommendation logic for the BS26 "Build your sale list" quiz (brand-agnostic).
// Input: quiz answers + window.SLQ_CONFIG + window.SLQ_PRODUCTS. Output: list slots (always ≥ 4 pieces), add-ons, totals.
// Every "why this pick" line is computed from the product actually shown (also after a swap): style lines only for designs
// in that style, "#1" only for rank 1, size claims only for the bag types they are true for.
(function () {
  const MIN_STOCK = 25; // hide rows ops flagged as nearly sold out
  const START_PIECES = 4; // the list always starts at the 80% tier; the shopper removes, not adds
  const LITTLE = ['mini wallet', 'wallet', 'makeup bag', 'charm'];
  const BAGS = ['handbag', 'small handbag', 'tote', 'crossbody', 'backpack'];
  const r2 = (x) => Math.round(x * 100) / 100;

  // Size + what fits, from the ops sheet `size` column (same blanks on all 3 brands; translated, plain words).
  // No line when ops has no measurement (top-grain, chain tote, charms). Tote: 18×12″ only — ops rows disagree on depth.
  const SIZES = {
    handbag: '13.8×10.6×5.5″ · fits a 13″ laptop, a book, a long wallet',
    'small handbag': '9.8×7.7×4.5″ · fits a phone, small wallet, keys',
    tote: '18×12″ · fits a 13″ laptop and books',
    circle: '7.5″ round, 2.5″ deep · fits a phone, cards, keys',
    envelope: '8.3×4.7×1.2″ · fits a phone, cards, cash',
    satchel: '5.4×7.8×4.2″ · fits a phone, cards, keys',
    backpack: '10.2×13×5.1″ mini backpack · fits an 11″ tablet, wallet',
    wallet: '4.3×7.9×1″ · fits a phone, cards, cash',
    'mini wallet': '4.5×3.2×1″ · fits cards, cash, coins',
    'makeup bag': '10×7.5×4.75″ · fits lipstick, brushes, skincare',
  };
  const sizeLine = (p) => {
    const id = p.handle + ' ' + (p.label || '');
    if (/top-grain|chain-tote|Chain tote/i.test(id)) return '';
    const k = /circle/i.test(id) ? 'circle' : /envelope/i.test(id) ? 'envelope' : /satchel/i.test(id) ? 'satchel' : p.type;
    return SIZES[k] || '';
  };
  // Shopify CDN resize: full-size mockups are ~230 KB webp each; at 2× display width they are ~15–40 KB (11-01 speed test).
  const cdnW = (url, w) => { if (!url || !/cdn\.shopify\.com|\/cdn\/shop\//.test(url)) return url || ''; try { const u = new URL(url, location.href); u.searchParams.set('width', w); return u.toString(); } catch (_) { return url; } };
  const pool = () => window.SLQ_PRODUCTS.filter((p) => p.stock >= MIN_STOCK);
  const lookById = (id) => {
    const L = window.SLQ_CONFIG.look;
    return L.options.find((o) => o.id === id) || (L.giftOnlyExtra.id === id ? L.giftOnlyExtra : null);
  };
  const inLook = (p, id) => { const l = lookById(id); return !!(l && l.designs.includes(p.design)); };
  const lookOf = (p, ids) => ids.map(lookById).find((l) => l && l.designs.includes(p.design)) || null;
  const priceAlone = (p) => r2(p.list * (1 - window.SLQ_CONFIG.tiers[1]));
  const priceAt = (p, n) => r2(p.list * (1 - (window.SLQ_CONFIG.tiers[Math.min(Math.max(n, 1), 4)] || 0))); // each piece's price when the list has n pieces

  // Ranked candidates: preferred types × preferred style designs first, then by best-seller rank; repeat designs sink.
  function candidates(types, lookIds, used) {
    const seen = {};
    window.SLQ_PRODUCTS.filter((p) => used.has(p.handle)).forEach((p) => { seen[p.design] = (seen[p.design] || 0) + 1; });
    const designs = lookIds.flatMap((id) => (lookById(id) || { designs: [] }).designs);
    const score = (p) => { const d = designs.indexOf(p.design); return (d === -1 ? 100 : d * 10) + types.indexOf(p.type) * 3 + (seen[p.design] || 0) * 15 + p.rank / 100; };
    return pool().filter((p) => !used.has(p.handle) && types.includes(p.type)).sort((a, b) => score(a) - score(b));
  }

  function slot(key, forLabel, whyOf, list, used) {
    if (!list.length) return null;
    used.add(list[0].handle);
    return { key, forLabel, whyOf, product: list[0], alts: list.slice(1, 6) };
  }
  const why = (s) => s.whyOf(s.product);
  const withAlts = (first, types, looks, used) => [first, ...candidates(types, looks, used).filter((p) => p.handle !== first.handle)]; // first pick + swap options
  const matchingLittle = (product, used) => (!product || !BAGS.includes(product.type) ? null
    : pool().find((p) => p.design === product.design && (p.type === 'wallet' || p.type === 'mini wallet') && !used.has(p.handle)) || null);

  const labelled = (s, labelOf) => (s ? Object.assign(s, { labelOf, forLabel: labelOf(s.product) }) : s);
  const sameDesignWhy = (base) => (p) => (p.design === base.design ? 'Same design, matching set' : 'A small add-on');
  const momentWhy = (m) => (p) => (!m.whyTypes || m.whyTypes.includes(p.type) ? m.why : m.whyAlt);
  const styleWhy = (lookId) => (p) => (inLook(p, lookId) ? lookById(lookId).why + ', the style you picked' : 'A small add-on');
  const giftWhy = (r, looks) => (p) => {
    if (p.rank === 1 && r.id === 'hardest') return 'Our #1 best seller';
    const l = lookOf(p, looks.filter((id) => id !== 'top'));
    return l ? l.why + ' — picked for ' + r.her : 'Picked for ' + r.her;
  };

  // One gift slot for a recipient (also used by "Add someone else": person + style = 2 taps).
  function giftSlot(a, rid, used, lookOverride) {
    const C = window.SLQ_CONFIG;
    const r = C.recipients.options.find((o) => o.id === rid);
    const kind = C.giftKind.options.find((o) => o.id === a.giftKind);
    const types = kind && kind.types ? kind.types : r.types;
    const look = lookOverride || (a.who === 'gifts' ? a.look : null);
    const looks = lookOverride ? [lookOverride, ...r.looks.filter((id) => id !== lookOverride)] // style tapped for this person ranks first
      : look && look !== r.looks[0] ? [r.looks[0], look, ...r.looks.slice(1)] : r.looks; // quiz-wide style: recipient's own style stays first
    return slot('r-' + rid + '-' + used.size, 'For ' + r.for, giftWhy(r, looks), candidates(types, looks, used), used);
  }

  function buildList(a) {
    const C = window.SLQ_CONFIG;
    const used = new Set(), slots = [];
    const add = (s) => { if (s) slots.push(s); return !!s; };

    if (a.who === 'me' || a.who === 'both') {
      const m = C.moment.options.find((o) => o.id === a.moment);
      const main = slot('me-main', a.who === 'both' ? 'The one you keep' : 'Your best match', momentWhy(m), candidates(m.types, [a.look], used), used);
      add(main);
      if (a.who === 'me') {
        const offLook = main && !inLook(main.product, a.look); // e.g. the Mom style exists only as wallets
        const w = offLook ? candidates(LITTLE, [a.look], used).find((p) => inLook(p, a.look)) : matchingLittle(main && main.product, used);
        if (w) add(labelled(slot('me-match', '', offLook ? styleWhy(a.look) : sameDesignWhy(main.product), withAlts(w, LITTLE, [a.look], used), used),
          (p) => (offLook ? (inLook(p, a.look) ? 'In your style' : 'One more for you') : p.design === main.product.design ? 'Goes with it' : 'One more for you')));
        add(slot('me-little', 'One more for you', () => 'A small extra for you', candidates(LITTLE, [], used), used));
        const other = BAGS.filter((t) => !m.types.includes(t));
        add(slot('me-shape', 'Another shape for you', (p) => (inLook(p, a.look) ? 'Another bag shape, same style' : 'Another bag shape for you'), candidates(other, [a.look], used), used));
      }
    }
    if (a.who === 'both' || a.who === 'gifts') (a.recipients || []).forEach((rid) => add(giftSlot(a, rid, used)));

    // Top up to 4 pieces: a recipient's own extra (Mom-design wallet), then matching wallets, then small gifts.
    (a.recipients || []).forEach((rid) => {
      const r = C.recipients.options.find((o) => o.id === rid);
      if (slots.length < START_PIECES && r.extraLook) {
        const x = candidates(LITTLE, [r.extraLook], used).find((p) => inLook(p, r.extraLook));
        if (x) add(slot('x-' + rid, 'Extra for ' + r.for, (p) => (inLook(p, r.extraLook) ? lookById(r.extraLook).why + ' — extra for ' + r.her : 'Extra for ' + r.her), withAlts(x, LITTLE, [r.extraLook], used), used));
      }
    });
    slots.slice().forEach((s) => { const w = slots.length < START_PIECES && matchingLittle(s.product, used); if (w) add(labelled(slot('m-' + w.handle, '', sameDesignWhy(s.product), withAlts(w, LITTLE, [], used), used), (p) => (p.design === s.product.design ? 'Goes with ' + s.product.design : a.who === 'me' ? 'One more for you' : 'A small gift'))); });
    const forMe = a.who === 'me'; // Just me: never call the top-up a gift
    while (slots.length < START_PIECES && add(slot('g-' + slots.length, forMe ? 'One more for you' : 'A small gift', () => (forMe ? 'A small extra for you' : 'An easy gift for someone'), candidates(LITTLE, a.look ? [a.look] : [], used), used)));
    return slots;
  }

  // Swap to the next alternative that is not already in the list (no duplicates).
  function swap(slots, idx) {
    const s = slots[idx], inList = new Set(slots.map((x) => x.product.handle));
    const k = s.alts.findIndex((p) => !inList.has(p.handle));
    if (k === -1) return false;
    const next = s.alts.splice(k, 1)[0];
    s.alts.push(s.product); s.product = next;
    if (s.labelOf) s.forLabel = s.labelOf(next);
    return true;
  }

  // "You might also need…" — one-tap add-ons that also lower the price of every piece.
  function suggestions(a, slots) {
    const used = new Set(slots.map((s) => s.product.handle)), out = [];
    slots.forEach((s) => { const w = out.length < 2 && matchingLittle(s.product, used); if (w) { used.add(w.handle); out.push({ kind: 'match', label: 'Add the matching ' + w.type + ' — ' + w.design, product: w, forLabel: 'Goes with ' + s.product.design }); } });
    return out;
  }

  function totals(items) {
    const tiers = window.SLQ_CONFIG.tiers, n = items.length, pct = tiers[Math.min(n, 4)] || 0;
    const listSum = items.reduce((s, p) => s + p.list, 0);
    const now = r2(items.reduce((s, p) => s + r2(p.list * (1 - pct)), 0));
    const firstAlone = n ? priceAlone(items[0]) : 0;
    return { n, pct, listSum: r2(listSum), now, saveNow: r2(listSum - now), toNext: n >= 4 ? 0 : 4 - n, firstAlone, extraForRest: r2(now - firstAlone) };
  }

  window.SLQ_LOGIC = { buildList, giftSlot, swap, suggestions, totals, lookById, inLook, why, priceAlone, priceAt, sizeLine, cdnW };
})();
